import React from 'react';

interface RiskInfoLayerType {
}

export default React.createContext<RiskInfoLayerType>({});
